import { render, staticRenderFns } from "./Devedor.vue?vue&type=template&id=68d956e4&scoped=true&"
import script from "./Devedor.vue?vue&type=script&lang=js&"
export * from "./Devedor.vue?vue&type=script&lang=js&"
import style0 from "./Devedor.vue?vue&type=style&index=0&id=68d956e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d956e4",
  null
  
)

export default component.exports